<template>
  <ListpageList />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
